import Localization from '@/service/localization'
import DeleteKeyDialog from './DeleteKeyDialog.vue'

import { Component, Vue } from 'vue-property-decorator'
import { CellEditorSelectorResult } from 'ag-grid-community'

@Component({
  name: 'c-delete-button-vue',

  components: {
    'c-delete-key-dialog': DeleteKeyDialog
  },

  template: `
    <div style="display: flex; align-items: center;">
      <c-delete-key-dialog ref="keyDlg"/>

      <v-btn icon
             color="primary"
             elevation="0"
             @click="btnClickedHandler">
        <v-icon>
          mdi-delete-outline
        </v-icon>
      </v-btn>
    </div>
  `,
})
export default class DeleteButtonVue extends Vue<CellEditorSelectorResult> {
  value = null

  protected async btnClickedHandler (): Promise<void> {
    const answer = await (this.$refs.keyDlg as any).open()

    if (answer == false) return

    await Localization.removeKey(
      this.params.data.projectId,
      this.params.data.keyId
    ).then(() => {
      this.params.api.applyTransactionAsync({ remove: [this.params.data] })
    })
  }
}
